import type { editor } from "monaco-editor"
import Slider from "@/v2-ui/slider"
import { applyInspectorEdit } from "@/v2-backoffice-client/layer/update/inspector/layer.update.inspector.utils"
import {
  SCALE_STOPS,
  formatScaleStop,
  nearestScaleStopIndex,
} from "@/v2-backoffice-client/layer/update/inspector/layer.update.inspector.guided.utils"

export type LayerUpdateInspectorGuidedScaleProps = {
  editor: editor.IStandaloneCodeEditor
  configuration: Record<string, unknown>
}

/**
 * Scale-range sliders over the common map scales: at which zoom the layer
 * appears (minScale, hidden further out) and disappears again (maxScale,
 * hidden further in). Writes root minScale/maxScale.
 */
function LayerUpdateInspectorGuidedScale(
  props: LayerUpdateInspectorGuidedScaleProps,
) {
  const { editor: editorInstance, configuration } = props

  const rows = [
    {
      key: "minScale",
      label: "Visible from",
      hint: "Hidden when zoomed out beyond this scale (No limit = always).",
    },
    {
      key: "maxScale",
      label: "Visible until",
      hint: "Hidden when zoomed in beyond this scale (No limit = always).",
    },
  ] as const

  return (
    <div className="flex flex-col gap-2">
      {rows.map((row) => {
        const stopIndex = nearestScaleStopIndex(configuration[row.key])
        return (
          <div key={row.key} className="flex flex-col gap-1" title={row.hint}>
            <span className="flex items-center justify-between">
              <span className="text-muted-foreground">{row.label}</span>
              <span className="font-mono text-[11px]">
                {formatScaleStop(SCALE_STOPS[stopIndex])}
              </span>
            </span>
            <Slider
              value={[stopIndex]}
              min={0}
              max={SCALE_STOPS.length - 1}
              step={1}
              aria-label={row.label}
              onValueChange={([next]) => {
                applyInspectorEdit(editorInstance, [row.key], SCALE_STOPS[next])
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

export default LayerUpdateInspectorGuidedScale
